import { useEffect } from "react";
import Page from "../../finwell/pages/Page";
import ChangePasswordSection from "../../components/profile/ChangePasswordSection";
import ReportDashboardSection from "../../components/Reports/ReportDashboardSection";
const ChangePasswordPage = () => {

    useEffect(() => {
        if (document.getElementById("id_page_404") !== null) {
            document.getElementById("id_page_404").style.display = "none";
        }
    }, [])

    return (<>
        <Page>
            <section className="change-password-admin mt-5">
                <ChangePasswordSection />
            </section>
        </Page>

    </>
    );
};

export default ChangePasswordPage;
